import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { XpoProdStylesDirective } from './prod-styles.directive';

@NgModule({
  imports: [CommonModule],
  exports: [XpoProdStylesDirective],
  declarations:  [XpoProdStylesDirective],
})
export class XpoProdStylesModule { }
